export const KKE_FORM_VERSION = "3.0";
export const TE_FORM_VERSION = "3.0";

export const RESET_REVISOR_CONFIG = {
  1: [
    "revisors_handling_1_question_alt_1",
    "revisors_handling_1_question_alt_2_samleklientbankkonti",
    "revisors_handling_1_question_alt_3_samleklientbankkonti",
    "revisors_handling_1_question_alt_4_beskrivelse",
  ],
  2: [
    "revisors_handling_2_question_alt_1",
    "revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover",
    "revisors_handling_2_question_alt_3",
    "revisors_handling_2_alt_3_antal_bokonti_ikke_oprettet",
    "revisors_handling_2_alt_3_antal_bokonti_stikprover",
    "revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_kurators_bobestyrers_advokatselskabets_navn",
    "revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_boets_navn",
    "revisors_handling_2_alt_3_antal_bokonti_ikke_separate",
    "revisors_handling_2_alt_3_bemaerkning",
  ],
  3: [
    "revisors_handling_3_question_alt_1",
    "revisors_handling_3_alt_2_bogfoeringssystem",
  ],
  4: [
    "revisors_handling_4_question_alt_1",
    "revisors_handling_4_revisionsbesoeg_dato",
    "revisors_handling_4_alt_2_uddybning",
  ],
  5: [
    "revisors_handling_5_question_alt_1",
    "revisors_handling_5_alt_2_beskriv_uoverenstemmelsen",
  ],
  6: [
    "revisors_handling_6_question_alt_1",
    "revisors_handling_6_alt_2_dato_reguleret",
    "revisors_handling_6_alt_2_forklaring",
    "revisors_handling_6_alt_3_uddybning",
  ],
  7: [
    "revisors_handling_7_question_alt_1",
    "revisors_handling_7_alt_2_beskrivelse",
  ],
  8: [
    "revisors_handling_8_question_alt_1",
    "revisors_handling_8_alt_2_beskrivelse",
  ],
  9: [
    "revisors_handling_9_question_alt_1",
    "revisors_handling_9_alt_2_beskrivelse",
  ],
  10: [
    "revisors_handling_10_question_alt_1",
    "revisors_handling_10_alt_1_dispensationDato",
    "revisors_handling_10_alt_1_dispensationPeriodeDatoFra",
    "revisors_handling_10_alt_1_dispensationPeriodeDatoTil",
    "revisors_handling_10_alt_2_uddybning",
  ],
  11: [
    "revisors_handling_11_question_alt_1",
    "revisors_handling_11_periode_fra",
    "revisors_handling_11_periode_til",
    "revisors_handling_11_alt_2_uddybning",
  ],
  12: [
    "revisors_handling_12_question_alt_1",
    "revisors_handling_12_table",
    "revisors_handling_12_alt_2_uddybning",
  ],
  13: [
    "revisors_handling_13_question_alt_1",
    "revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve",
    "revisors_handling_13_question_alt_2_uddybning_table",
  ],
  14: [
    "revisors_handling_14_question_alt_1",
    "revisors_handling_14_alt_2_uddybning",
  ],
  15: [
    "revisors_handling_15_question_alt_1",
    "revisors_handling_15_alt_2_uddybning",
  ],
  16: [
    "revisors_handling_16_question_alt_1",
    "revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve",
    "revisors_handling_16_question_alt_2_uddybning_table",
  ],
};

export const SAFE_FIELDS = {
  revisors_handling_2_question_alt_1: [
    "revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover",
  ],
  revisors_handling_2_question_alt_3: [
    "revisors_handling_2_alt_1_og_3_antal_bokonti_stikprover",
    "revisors_handling_2_alt_3_antal_bokonti_ikke_oprettet",
    "revisors_handling_2_alt_3_antal_bokonti_stikprover",
    "revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_kurators_bobestyrers_advokatselskabets_navn",
    "revisors_handling_2_alt_3_antal_bokonti_ikke_opprettet_i_boets_navn",
    "revisors_handling_2_alt_3_antal_bokonti_ikke_separate",
    "revisors_handling_2_alt_3_bemaerkning",
  ],
  revisors_handling_3_question_alt_2: [
    "revisors_handling_3_alt_2_bogfoeringssystem",
  ],
  revisors_handling_4_question_alt_1: [
    "revisors_handling_4_revisionsbesoeg_dato",
  ],
  revisors_handling_4_question_alt_2: [
    "revisors_handling_4_revisionsbesoeg_dato",
    "revisors_handling_4_alt_2_uddybning",
  ],
  revisors_handling_5_question_alt_2: [
    "revisors_handling_5_alt_2_beskriv_uoverenstemmelsen",
  ],
  revisors_handling_6_question_alt_2: [
    "revisors_handling_6_alt_2_dato_reguleret",
    "revisors_handling_6_alt_2_forklaring",
  ],
  revisors_handling_6_question_alt_3: ["revisors_handling_6_alt_3_uddybning"],
  revisors_handling_7_question_alt_2: ["revisors_handling_7_alt_2_beskrivelse"],
  revisors_handling_8_question_alt_2: ["revisors_handling_8_alt_2_beskrivelse"],
  revisors_handling_9_question_alt_2: ["revisors_handling_9_alt_2_beskrivelse"],
  revisors_handling_10_question_alt_1: [
    "revisors_handling_10_alt_1_dispensationDato",
    "revisors_handling_10_alt_1_dispensationPeriodeDatoFra",
    "revisors_handling_10_alt_1_dispensationPeriodeDatoTil",
  ],
  revisors_handling_10_question_alt_2: ["revisors_handling_10_alt_2_uddybning"],
  revisors_handling_11_question_alt_1: [
    "revisors_handling_11_periode_fra",
    "revisors_handling_11_periode_til",
  ],
  revisors_handling_11_question_alt_2: [
    "revisors_handling_11_periode_fra",
    "revisors_handling_11_periode_til",
    "revisors_handling_11_alt_2_uddybning",
  ],
  revisors_handling_12_question_alt_1: ["revisors_handling_12_table"],
  revisors_handling_12_question_alt_2: ["revisors_handling_12_alt_2_uddybning"],
  revisors_handling_13_question_alt_1: [
    "revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve",
  ],
  revisors_handling_13_question_alt_2: [
    "revisors_handling_13_question_alt_2_uddybning_table",
    "revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve",
  ],
  revisors_handling_14_question_alt_2: ["revisors_handling_14_alt_2_uddybning"],
  revisors_handling_15_question_alt_2: ["revisors_handling_15_alt_2_uddybning"],
  revisors_handling_16_question_alt_1: [
    "revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve",
  ],
  revisors_handling_16_question_alt_2: [
    "revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve",
    "revisors_handling_16_question_alt_2_uddybning_table",
  ],
};

export const SPECIAL_RULES = {
  revisors_handling_10_question_alt_1_fandt_ikke_alt_ok: [
    "revisors_handling_10_alt_1_dispensationDato",
    "revisors_handling_10_alt_1_dispensationPeriodeDatoFra",
    "revisors_handling_10_alt_1_dispensationPeriodeDatoTil",
  ],
  revisors_handling_10_question_alt_1_fandt_alt_ok: [
    "revisors_handling_10_alt_2_uddybning",
  ],
  revisors_handling_11_question_alt_1_fandt_alt_ok: [
    "revisors_handling_11_alt_2_uddybning",
  ],
  revisors_handling_12_question_alt_1_fandt_alt_ok: [
    "revisors_handling_12_alt_2_uddybning",
  ],
  revisors_handling_14_question_alt_1_fandt_alt_ok: [
    "revisors_handling_14_alt_2_uddybning",
  ],
  revisors_handling_15_question_alt_1_fandt_alt_ok: [
    "revisors_handling_15_alt_2_uddybning",
  ],
  revisors_handling_16_question_alt_1_fandt_alt_ok: [
    "revisors_handling_16_question_alt_2_uddybning_table",
  ],
};
